import { connect } from 'react-redux';

import SecureRouteComponent from './SecureRoute';

const mapStateToProps = ({ auth }) => ({
  token: auth.token,
});

export default connect(mapStateToProps)(SecureRouteComponent);
